import React, { useState, useCallback, useEffect, useRef } from 'react'
import PortfolioService from '../../../services/portfolio.service'
import moment from 'moment'
import LayoutWithOutAccountCard from '../../Layout/layout-without-card'
import Loading from 'custom/assets/loaders/Loading'
import Download from 'custom/assets/icons/download.svg'
import NeoButton from '../../../components/NeoButton/NeoButton'
import NeoInput from '../../../components/NeoInput/NeoInput'
import InputError from '../../../components/InputError/InputError'
import Modal from '../../../components/Modal/Modal'
import { useModal } from 'react-modal-hook'
import * as Yup from 'yup'
import { Formik, Form, Field } from 'formik'
import { useHistory } from 'react-router-dom'
import CustomPagination from '../../../components/pagination'
import {MT103Schema} from "../../../schemas/downloadCenter"

import { BUTTON_KEYS, MT103_KEYS, VALIDATION_KEYS } from '../../../utils/translation-constants'
import { useTranslation } from 'react-i18next';
import validationConfig from 'custom/config/validation.config.json'
const mt103Config = validationConfig['downloadCenter']['mt103']

export default function MT103(waitCondition = true) {
  const [accountDetails, setAccountDetails] = useState([])
  const [refNumbers, setRefNumbers] = useState()
  const history = useHistory()
  const [downloadMessage, setDownloadMessage] = useState()
  const [loadingDownload, setLoadingDownload] = useState(false)
  const [error, setError] = useState('')
  const [stage, setStage] = useState(0)
  const [loading, setLoading] = useState(false)
  const [minValue, setMinValue] = useState(0)
  const [maxValue, setMaxValue] = useState(10)
  const {t}=useTranslation()

  const [showModal, hideModal] = useModal(
    () => (
      <Modal>
        <h6>{error}</h6>
        <div className='mt-4 col-6 mx-auto'>
          <NeoButton
            type='button'
            mode='newDesign'
            text={t(BUTTON_KEYS.CLOSE)}
            onClick={() => {
              hideModal()
              history.push('/dashboard')
            }}
          />
        </div>
      </Modal>
    ),
    [error],
  )

  useEffect(() => {
    getAccountDetails()
  }, [])

  const getAccountDetails = useCallback(
    async (values) => {
      try {
        const response = await PortfolioService.getAccountDetails({ ...values, fetchSavings: true })
        if (response.status === 200) {
          setAccountDetails(response.data['accountSummaryList'])
          setStage(1)
        }
      } catch (err) {
        setError(err.error)
        setStage(1)
        //showModal()
      }
    },
    [showModal],
  )

  const getMT103RefNumbers = useCallback(async (values) => {
    try {
      setLoading(true)
      const response = await PortfolioService.getMT103RefNumbers(values)
      if (response.status === 200) {
        setRefNumbers(response.data['contractRef'])
        setLoading(false)
      }
    } catch (err) {
      setLoading(false)
      console.error(err)
    }
  }, [])

  const getMt103receipt = useCallback(
    async (values) => {
      try {
        setLoading(true)
        const response = await PortfolioService.getMt103receipt(values)
        if (response.status === 200) {
          setDownloadMessage(response.data)
          setLoading(false)
        }
      } catch (err) {
        setLoading(false)
        var enc = new TextDecoder('utf-8')
        var arr = new Uint8Array(err.data)
        console.log(JSON.parse(enc.decode(arr)))
        setLoading(false)
        setError(JSON.parse(enc.decode(arr)))
        //showModal()
      }
    },
    [showModal],
  )

  function renderSwitch() {
    switch (stage) {
      case 0:
        return renderLoading()
      case 1:
        return renderReceiptsViewForm()
      default:
        return renderReceiptsViewForm()
    }
  }

  function renderLoading() {
    return (
      <div className='mx-4 rounded d-flex justify-content-center align-items-center'>
        <Loading width='50px' height='50px' />
      </div>
    )
  }

  function renderReceiptsViewForm() {
    return (
      <div>
        <Formik
          initialValues={{
            sourceAccount: '',
            fromDate: '',
            toDate: '',
          }}
          onSubmit={getMT103RefNumbers}
          validationSchema={MT103Schema}>
          {({ isSubmitting, errors, touched, handleChange }) => (
            <Form>
              <div className='form-group col-12'>
                <label className='control-label'>{t(MT103_KEYS.ACCOUNT_NO)} {mt103Config['isAccountNoRequired'] ? '*' : ''}</label>
                <Field
                  as='select'
                  className='form-control'
                  name='sourceAccount'
                  disabled={loading}
                  placeholder={t(MT103_KEYS.SELECT_ACCOUNT_NO)}>
                  <option disabled value='' />
                  {waitCondition ? (
                    accountDetails.map((item, index) => (
                      <option key={index} value={item.accountNo}>
                        {item.accountNo}
                      </option>
                    ))
                  ) : (
                    <option disabled value='' />
                  )}
                </Field>
                <InputError text={errors.sourceAccount} touched={touched.sourceAccount} />
              </div>
              <div className='form-group col-12'>
                <NeoInput
                  showAsterisk={mt103Config['isFromDateRequired']}
                  text={t(MT103_KEYS.FROM_DATE)}
                  name='fromDate'
                  type='date'
                  disabled={loading}
                  onChange={handleChange}
                  max={moment(new Date()).format('YYYY-MM-DD')}
                  //value={values.fromDate}
                />
                <InputError text={errors.fromDate} touched={touched.fromDate} />
              </div>
              <div className='form-group col-12'>
                <NeoInput
                  showAsterisk={mt103Config['isToDateRequired']}
                  text={t(MT103_KEYS.TO_DATE)}
                  name='toDate'
                  type='date'
                  disabled={loading}
                  onChange={handleChange}
                  max={moment(new Date()).format('YYYY-MM-DD')}
                  //value={values.toDate}
                />
                <InputError text={errors.toDate} touched={touched.toDate} />
              </div>
              <div className='mt-3'>
                {loading ? (
                  renderLoading()
                ) : (
                  <NeoButton
                    disabled={loadingDownload}
                    type='submit'
                    text={t(BUTTON_KEYS.SUBMIT)}
                    mode='newDesign'
                  />
                )}
              </div>
            </Form>
          )}
        </Formik>

        {refNumbers !== null && refNumbers !== undefined && (
          <>
            <div>
              <div className='heading6'>
                <div className='reference-number'>{t(MT103_KEYS.REFERENCE_NO)}</div>
              </div>
              {refNumbers !== undefined &&
                refNumbers.slice(minValue, maxValue).map((item, index) => (
                  <>
                    <div className='reference-number-row mb-3' key={index}>
                      <div className='reference-number-col'>{item}</div>
                      <div className='reference-number-col'>
                        <img
                          disabled={loading}
                          src={Download}
                          alt='download'
                          onClick={() => getMt103receipt(item)}
                        />
                      </div>
                    </div>
                  </>
                ))}
              <div>
                <CustomPagination
                  defaultPageSize={10}
                  setMaxValue={(value) => setMaxValue(value)}
                  setMinValue={(value) => setMinValue(value)}
                  totalLength={refNumbers.length}
                  defaultCurrent={1}
                />
              </div>
            </div>
            {refNumbers.length === 0 && (
              <p style={{ textAlign: 'center', marginTop: 20 }}>{t(MT103_KEYS.NO_RECORDS_FOUND)}</p>
            )}
          </>
        )}
      </div>
    )
  }

  return (
    <LayoutWithOutAccountCard breadCumKey='BENE_MT103' showEmptySpace={true} keyPath={'MT103'}>
      <div className='heading-style'>{t(MT103_KEYS.TITLE)}</div>
      <div className='new-design-form-style'>{renderSwitch()}</div>
    </LayoutWithOutAccountCard>
  )
}
